// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d15319c","732":"45ff4157"}[chunkId] + ".chunk.js";
};